export const NUMBER_REGEXP = /^\d+$/;
